export const dagmaraRacaPiekarz = {
    'meta': {
        'title': 'Psychiatra dzieci i młodzieży Dagmara Raca-Piekarz',
        'description': 'Lekarz psychiatra dzieci i młodzieży z wieloletnim stażem. Doświadczenie zawodowe zdobywałam pracują w szpitalu oraz w poradniach zdrowia psychicznego.'
    },
    'url': {
        'address': '/torun/zespol/psychiatra-dzieci-i-mlodziezy-dagmara-raca-piekarz/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/dagmara-raca-piekarz.jpg',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra dzieci i młodzieży Dagmara Raca-Piekarz'
        }
    }
}